import {useEffect, useState} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {ErrorBoundary} from '../../common/Toast/ToastContext';
import {useDispatch} from 'react-redux';
import Loader from '../../common/Loader';
import AppHeader from '../AppHeader';
import AppFooter from '../AppFooter';
import NavigationDrawer from '../NavigationDrawer';
import {setSectionTitle} from '../../../store/navigation';
import {set as setLoggedInUser} from '../../../store/loggedInUser';
import {setAccounts} from '../../../store/accounts';
import {setProjects} from '../../../store/projects';
import {setTaxConfigs} from '../../../store/taxConfigs';
import {setCompanies} from '../../../store/companies';
import {setAccountSources} from '../../../store/accountSources';
import {setCurrencyRates} from '../../../store/currencyRates';
import {loadCurrentUser} from '../../../api/walletUser';
import {findAllAccounts} from '../../../api/capitalAccount';
import {findAllProjects} from '../../../api/project';
import {findAllTaxConfigs} from '../../../api/taxConfig';
import {findAllCompanies} from '../../../api/company';
import {findAllSources} from '../../../api/accountSource';
import {findAllCurrencyRates} from '../../../api/currencyRate';
import './AppMenu.scss';

const SECTION_TITLES = {
    '/dashboard':     'Dashboard',
    '/transactions':  'Transactions',
    '/projects':      'Projects',
    '/accounts':      'Accounts',
    '/milestones':    'Milestones',
    '/tax':           'Tax',
    '/timeline':      'Timeline',
    '/currency':      'Currency Rates',
};

const resolveSectionTitle = (pathname) => {
    const match = Object.entries(SECTION_TITLES).find(([path]) => pathname.startsWith(path));
    return match ? match[1] : '';
};

const applyTheme = (theme) => {
    const t = theme || 'dark';
    document.documentElement.dataset.theme = t;
    localStorage.setItem('theme', t);
};

const AppMenu = () => {
    const [loaded, setLoaded] = useState(false);
    const dispatch = useDispatch();
    const {pathname} = useLocation();

    useEffect(() => {
        dispatch(setSectionTitle(resolveSectionTitle(pathname)));
    }, [pathname, dispatch]);

    useEffect(() => {
        const saved = localStorage.getItem('theme') || 'dark';
        applyTheme(saved);

        Promise.all([
            loadCurrentUser(),
            findAllAccounts(),
            findAllProjects(),
            findAllTaxConfigs(),
            findAllCompanies(),
            findAllSources(),
            findAllCurrencyRates(),
        ])
            .then(([user, accounts, projects, taxConfigs, companies, sources, currencyRates]) => {
                dispatch(setLoggedInUser(user));
                dispatch(setAccounts(accounts));
                dispatch(setProjects(projects));
                dispatch(setTaxConfigs(taxConfigs));
                dispatch(setCompanies(companies));
                dispatch(setAccountSources(sources));
                dispatch(setCurrencyRates(currencyRates));
            })
            .catch(() => {})
            .finally(() => setLoaded(true));
    }, [dispatch]);

    return (
        <div className="wallet-app">
            {loaded ? (
                <>
                    <AppHeader/>
                    <div className="wallet-app__body">
                        <NavigationDrawer/>
                        <main className="wallet-app__content">
                            <ErrorBoundary><Outlet/></ErrorBoundary>
                        </main>
                    </div>
                    <AppFooter/>
                </>
            ) : <Loader fullScreen={true}/>}
        </div>
    );
};

export default AppMenu;
